import React, {useId} from "react";
import {observer} from "mobx-react-lite";
import {RadioButton} from "primereact/radiobutton";

import systemStore from "../storage/SystemStore";


const Radio = ({
    label,
    store,
    prop,
    checked,
    onChange,
    inputId,
    name,
    disabled = false,
    className = "",
    wrapperClassName = "",
    ...rest
}) => {
    const generatedId = useId();

    const storeBound =
        store !== undefined &&
        prop !== undefined;


    const currentChecked =
        checked !== undefined
            ? Boolean(checked)
            : storeBound
                ? Boolean(store[prop])
                : false;


    const id =
        inputId ||
        `radio-${generatedId.replace(/:/g, "")}`;


    const handleChange = (event) => {
        if (storeBound) {
            store.setProperty(prop, true);
        }

        onChange?.(true, event);
    };


    return (
        <div
            className={[
                "flex align-items-center",
                wrapperClassName,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <RadioButton
                {...rest}

                inputId={id}

                name={name || prop}

                checked={currentChecked}

                disabled={
                    disabled ||
                    systemStore.loading
                }

                className={className}

                onChange={handleChange}
            />


            {label && (
                <label
                    htmlFor={id}
                    className="ml-2"
                >
                    {label}
                </label>
            )}
        </div>
    );
};


export default observer(Radio);